import React from "react";
import { FundRecommendationResponse } from "@rentablo/api/recommender";
import i18next from "i18next";
import ThemaIcon from "@icons/myicons/pie-graph.svg?react";
import WorldIcon from "@icons/myicons/world.svg?react";

export const getCards = (recommendation: FundRecommendationResponse) => [
  {
    label: i18next.t("recommender.detailsModal.details.thema"),
    value: recommendation.fund.focus_asset,
    icon: <ThemaIcon />,
  },
  {
    label: i18next.t("recommender.detailsModal.details.region"),
    value: recommendation.fund.peer_group,
    icon: <WorldIcon />,
  },
];

export const getIdentifiers = (recommendation: FundRecommendationResponse) => [
  {
    label: i18next.t("recommender.detailsModal.header.isin"),
    value: recommendation?.fund?.isin ?? "-",
  },
  {
    label: i18next.t("recommender.detailsModal.header.wkn"),
    value: recommendation?.fund?.emitter,
  },
];
